
export const navMenus = [
  // {
  //   title: "AI Business",
  //   path: "/WISplatform",
  //   children: [
  //     { title: "WISplatform", path: "/WISplatform" },
  //     { title: "WISaicc", path: "/WISaicc" },
  //     { title: "WISbot", path: "/WISbot" },
  //     { title: "WISserch", path: "/WISserch" },
  //     { title: "WISvec", path: "/WISvec" },
  //     { title: "WISrag", path: "/WISrag" },
  //     { title: "WISdoc", path: "/WISdoc" },
  //     { title: "WISscrap", path: "/WISscrap" },
  //     { title: "WISocr", path: "/WISocr" },
  //     { title: "WISvoice", path: "/WISvoice" },
  //     { title: "WISvision", path: "/WISvision" },
  //   ],
  // },
  {
     title: "AI Business",
     path: "/WISplatform",
     groups: [
      {
        title: "AI플랫폼 ",
        type: "detailed",
        children: [
          { title: "WISplatform", desc: "AI 통합 플랫폼", path: "/WISplatform" },
          { title: "WISaicc", desc: "AI 콜센터(AICC)와 챗봇", path: "/WISaicc" },
        ]
      },
      {
        title: "AI 검색 ",
        type: "detailed",
        children: [
          { title: "WISbot", desc: "기업 맞춤형 RAG 기반 생성형 챗봇 솔루션", path: "/WISbot" },
          { title: "WISsearch", desc: "키워드 AI 검색 솔루션", path: "/WISserch" },
          { title: "WISvec", desc: "AI 벡터 검색 솔루션", path: "/WISvec" },
          { title: "WISrag", desc: "맞춤형 RAG 애플리케이션 솔루션", path: "/WISrag" },
        ]
      },
      {
        title: "문서·데이터 AI ",
        type: "detailed",
        children: [
          
          { title: "WISdoc", desc: "AI 문서 처리 솔루션", path: "/WISdoc" },
          { title: "WISscrap", desc: "Nocode기반 데이터 수집/구축 파이프라인", path: "/WISscrap" },
          { title: "WISocr", desc: "비전언어모델(VLM)기반 지능형 문자인식 솔루션", path: "/WISocr" },
        ]
      },
      {
        title: "음성·영상 AI ",
        type: "detailed",
        children: [
          
          { title: "WISvoice", desc: "실시간 음성 서비스 솔루션", path: "/WISvoice" },
          { title: "WISvision", desc: "이미지 영상 분석 솔루션", path: "/WISvision" },
        ]
      },
    ]
  },
  {
    title: "SI Business",
    path: "/iTConsulting",
    children: [
      { title: "IT Consulting", path: "/iTConsulting" },
      { title: "System Integration", path: "/systemIntegration" },
      { title: "Solution", path: "/solution" },
      { title: "IT Service", path: "/iTService" },
      { title: "구축사례", path: "/constructionCase" },
    ],
  },
  {
    title: "Company",
    path: "/comOverview",
    children: [
      { title: "회사소개", path: "/comOverview" },
      { title: "회사연혁", path: "/comHisPubList" },
      { title: "회사연혁 리스트", path: "/comHisPrivList" },
      { title: "인증 및 협약", path: "/coreCompetence" },
    ],
  },
  {
    title: "ESG",
    path: "/visionObjective",
    children: [
      { title: "ESG", path: "/visionObjective" },
      { title: "환경경영", path: "/enviroMgmt" },
      { title: "인권경영", path: "/HumanRightMgmt" },
      { title: "안전보건경영", path: "/safetyMgmt" },
      { title: "윤리경영", path: "/ethicalMgmt" },
      { title: "사회공헌", path: "/socialContirb" },
    ],
  },
  {
    title: "Contact Us",
    path: "/locationInfo",
    children: [
      { title: "Contact Us", path: "/locationInfo" },
      { title: "제품 문의하기", path: "/Inquiry" },
    ],
  },
  {
    title: "Recruit",
    path: "/recruitmentGuide",
  },
];
